/**
 * constants.ts
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
 */

export const MOBILE_CUTOFF = 768;
export const MAX_UINT32 = 4294967296; // 2^32

export type ResolveFn<T> = (result: T) => void;
export type RejectFn = (err: any) => void;

export interface ClassToggles {
  chatContainer: boolean,
  showLeftNav: boolean,
  showRightDetail: boolean,
  multipleAccounts: boolean,
  withHuddle: boolean,
  hideChatInput: boolean
}
